import PopperMenu from "@metacrm/metacrm-material-ui/dist/PopperMenu";
import { Box } from "@mui/material";
import config from "config";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import useNavigateEntity from "hooks/useNavigateEntity";
import { useRef, useState } from "react";
import { useOutletContext } from "react-router";
import { useIntl } from "react-intl";

export default function XPopMenu({ xId, handleDelete, isPublic }) {
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState(false);
  const [entityName] = useOutletContext();
  const anchorRef = useRef(null);
  const { navigateEntity } = useNavigateEntity();
  const handleClose = () => {
    setOpen(false);
  };

  const copyFn = useCopyToClipboard(
    `${config.portalUrl}/x/shared/${entityName}/${xId}`
  );

  const itemList = [
    {
      children: (
        <Box color="#555" className="item-flex">
          <i className="meta-crm-icon-ic_edit-2 font-size-16" />
          <Box>{formatMessage({ id: "global.btn.edit" })}</Box>
        </Box>
      ),
      func: (e) => {
        e.stopPropagation();
        navigateEntity(`/kol/xCampaign/add/${xId}`);
      },
    },
    isPublic
      ? {
          children: (
            <Box color="#555" className="item-flex">
              <i className="meta-crm-icon-ic_share_alt font-size-16" />
              <Box>{formatMessage({ id: "global.btn.copyLink" })}</Box>
            </Box>
          ),
          func: (e) => {
            e.stopPropagation();
            copyFn();
          },
        }
      : null,
    {
      children: (
        <Box color="#555" className="item-flex">
          <i className="meta-crm-icon-ic_trash font-size-16" />
          <Box>{formatMessage({ id: "global.btn.delete" })}</Box>
        </Box>
      ),
      func: (e) => {
        e.stopPropagation();
        handleDelete();
      },
    },
  ].filter((item) => item);

  return (
    <>
      <Box
        ref={anchorRef}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <i className="meta-crm-icon-ic_more font-size-32" />
      </Box>

      <PopperMenu
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        itemList={itemList}
      />
    </>
  );
}
